<app-navigation
  [currentPage]="'dashboard'"
  [inspectionKey]="selectedInspectionKey"></app-navigation>

<div class="page-content" id="inspections">
  <table class="table table-striped table-hover bsg-table">
    <thead>
      <tr>
        <th>
          <div class="form-check form-check-indented">
            <label class="checkbox">
              <input
                name="selectAll"
                type="checkbox"
                [disabled]="!inspections?.length"
                [(ngModel)]="selectAllChecked"
                (change)="toggleSelectAll()" />
              <span class="checkmark"></span>
            </label>
          </div>
        </th>
        <th>
          <a href (click)="sortBy('name')">
            <span translate>Name der Einheit</span>
            @if (sortedBy === 'name') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('address')">
            <span translate>Strasse</span>
            @if (sortedBy === 'address') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('postalZone')">
            <span translate>PLZ</span>
            @if (sortedBy === 'postalZone') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('town')">
            <span translate>Ort</span>
            @if (sortedBy === 'town') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('inspectionType')">
            <span translate>Kontrolle</span>
            @if (sortedBy === 'inspectionType') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('inspectionDate')">
            <span translate>Datum</span>
            @if (sortedBy === 'inspectionDate') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('inspectionStyleName')">
            <span translate>Kontrollart</span>
            @if (sortedBy === 'inspectionStyleName') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('inspectionStatus')">
            <span translate>Status</span>
            @if (sortedBy === 'inspectionStatus') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('tvdNumber')">
            <span translate>TVD-Nr.</span>
            @if (sortedBy === 'tvdNumber') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('burNumber')">
            <span translate>BUR-Nr.</span>
            @if (sortedBy === 'burNumber') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('cantonId')">
            <span translate>Kant. ID</span>
            @if (sortedBy === 'cantonId') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
        <th>
          <a href (click)="sortBy('inspectorName')">
            <span translate>Kontrolleur</span>
            @if (sortedBy === 'inspectorName') {
              <span [class]="classNames" aria-hidden="true"></span>
            }
          </a>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (inspection of inspections; track inspection) {
        <tr
          [class.selected-row]="inspection.isSelected"
          [ngClass]="{ highlightedRow: !inspection.isActive, 'pointer-cursor': true }">
          <td>
            <div class="form-check form-check-indented">
              <label class="checkbox">
                <input
                  name="selectRow"
                  type="checkbox"
                  [(ngModel)]="inspection.isSelected"
                  (change)="selectionChanged()" />
                <span class="checkmark"></span>
              </label>
            </div>
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.name }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.address }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.postalZone }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.town }}
          </td>
          @if (inspection.inspectionType) {
            <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
              {{ inspection.inspectionType | i18nText }}
            </td>
          }
          @if (!inspection.inspectionType) {
            <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
              {{ inspection.categoryShortNames | i18nTextList }}
            </td>
          }
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.inspectionDate | date: 'dd.MM.yyyy' }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.inspectionStyleName }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.inspectionStatus | i18nText }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.tvdNumber }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.burNumber }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.cantonId }}
          </td>
          <td routerLink="/detail/{{ inspection.inspectionKey }}" class="pointer-cursor">
            {{ inspection.inspectorName }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

@if (inspections?.length) {
  <div id="actionpane" class="p-2 footer-button">
    <div
      ngbPopover="{{ 'LoginRequiredForUpload' | translate }}"
      placement="right"
      triggers="mouseenter:mouseleave"
      disablePopover="{{ connectionStateService.loggedIn }}">
      <button
        class="btn btn-primary me-2"
        (click)="openUploadInspectionsConfirmation()"
        [disabled]="!canUploadInspections() || !connectionStateService.loggedIn">
        @if (uploading) {
          <span class="fas fa-circle-notch fa-spin fa-fw"></span>
        }
        <span class="fas fa-upload"></span>
        <span translate>Hochladen</span>
      </button>
    </div>
    <div>
      <button
        class="btn btn-primary mr2"
        (click)="openDeleteConfirmation()"
        [disabled]="!hasSelectedItems()">
        <span class="fas fa-minus-circle"></span>
        <span translate>Entfernen</span>
      </button>
    </div>
    <app-scroll-to-top class="align-right me-2"></app-scroll-to-top>
  </div>
}
